<script lang="ts">
  import { onDestroy } from "svelte";
  import { scale } from "svelte/transition";

  export let name: string;
  export let store: any;
  export let type: "departments" | "locations" | null = null;
  export let level: any;
  export let full: any = "";
  export let hasChildren: boolean = false;
  export let isLast: boolean = false;

  let selected = false;

  store.subscribe((rs) => {
    if (type === "locations") {
      if (level === 1) {
        selected = rs.filter((l) => l.name === name).length > 0;
      }

      if (level === 2) {
        const topLevel = full.split(", ").reverse()[0];
        selected =
          rs.filter((l) => {
            const topLevelMatch = l.name === topLevel;
            if (topLevelMatch) {
              let childrenMatchesCount = l.children.filter((c) => {
                return c.name === name;
              }).length;
              return childrenMatchesCount > 0;
            } else {
              return false;
            }
          }).length > 0;
      }

      if (level === 3) {
        const reverseSplit = full.split(", ").reverse();
        const topLevel = reverseSplit[0];

        selected =
          rs.filter((l) => {
            const topLevelMatch = l.name === topLevel;
            if (topLevelMatch) {
              let childrenMatchesCount = l.children.filter((c) => {
                if (c.name === reverseSplit[1]) {
                  return (
                    c.children.filter((child) => {
                      return child.name === name;
                    }).length > 0
                  );
                }
              }).length;
              return childrenMatchesCount > 0;
            } else {
              return false;
            }
          }).length > 0;
      }

      // console.log(rs);
    } else {
      selected = rs.includes(name);
    }
  });

  onDestroy(() => {
    store.update((curr) => {
      if (type === "locations") {
        // do nothing
      } else {
        const index = curr.indexOf(name);
        if (index !== -1) {
          curr.splice(index, 1);
        }
      }
      return curr;
    });
  });

  const handleClick = () => {
    store.update((curr) => {
      if (type === "locations") {
        if (level === 1) {
          let matchIndex = -1;

          curr.forEach((l, i) => {
            if (l.name === name) {
              matchIndex = i;
            }
          });

          if (matchIndex === -1) {
            curr.push({
              name,
              children: [],
            });
          } else {
            curr.splice(matchIndex, 1);
          }
        }

        if (level === 2) {
          const topLevel = full.split(", ").reverse()[0];
          const topLevelMatch = curr.filter((l) => l.name === topLevel)[0];

          if (topLevelMatch && topLevelMatch.children) {
            let matchIndex = -1;
            topLevelMatch.children.forEach((child, i2) => {
              if (child.name === name) {
                matchIndex = i2;
              }
            });

            if (matchIndex === -1) {
              topLevelMatch.children.push({
                name,
                children: [],
              });
            } else {
              topLevelMatch.children.splice(matchIndex, 1);
            }
          }
        }

        if (level === 3) {
          const reverseSplit = full.split(", ").reverse();
          const topLevel = reverseSplit[0];
          const topLevelMatch = curr.filter((l) => l.name === topLevel)[0];

          if (topLevelMatch && topLevelMatch.children) {
            let secondLevelIndex = -1;
            topLevelMatch.children.forEach((c2, iz) => {
              if (c2.name === reverseSplit[1]) {
                secondLevelIndex = iz;
              }
            });
            const secondLevelMatch = topLevelMatch.children[secondLevelIndex];
            // console.log(console.log(secondLevelIndex));

            if (secondLevelMatch) {
              let matchIndex = -1;
              secondLevelMatch.children.forEach((child, i3) => {
                if (child.name === name) {
                  matchIndex = i3;
                }
              });
              // console.log(matchIndex);

              if (matchIndex === -1) {
                secondLevelMatch.children.push({
                  name,
                  children: [],
                });
              } else {
                secondLevelMatch.children.splice(matchIndex, 1);
              }
            } else {
              // console.log('no match');
            }
          }
        }
      } else {
        const index = curr.indexOf(name);
        if (index !== -1) {
          curr.splice(index, 1);
        } else {
          curr.push(name);
        }
      }

      // if (type === 'locations') {
      //   console.log(curr);
      // }
      return curr;
    });
  };
</script>

<div
  class="flex items-center select-none cursor-pointer text-[16px] font-light {level ===
    1 || hasChildren
    ? 'py-4'
    : 'py-2'}"
  style={(level === 1 || hasChildren) && !isLast
    ? "border-bottom:1px solid rgba(0,0,0,0.1)"
    : ""}
  tabindex="-1"
  role="button"
  on:click={handleClick}
  on:keydown={handleClick}
>
  <div class="flex-auto flex items-center">
    <div class="filter-box">
      {#if selected}
        <div
          transition:scale|global={{ duration: 200 }}
          class="filter-box-selected"
        ></div>
      {/if}
    </div>
    <div>{name}</div>
  </div>
  {#if hasChildren}
    <div style="transform:{selected ? '' : 'rotate(180deg)'}">
      <svg
        class="w-[14px] h-[9px]"
        viewBox="0 0 14 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ><path
          d="M1.703 7.322l5.648-5.643 5.647 5.643"
          stroke="#242021"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        /></svg
      >
    </div>
  {/if}
</div>

{#if selected}
  <slot />
{/if}

<style lang="scss">
  .filter-box {
    margin-right: 10px;
    flex: 0 0 15px;
    height: 15px;
    width: 15px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    position: relative;
    .filter-box-selected {
      background-color: rgb(var(--color-red-secondary));
      @apply absolute inset-[2px] rounded-[2px];
    }
  }
</style>
